<template>
  <v-card rounded="lg" flat>
    <v-card-title class="subtitle-1 font-weight-bold"
      >Informações adicionais</v-card-title
    >
    <v-card-text>      
      <v-textarea
        label="Observações"
        rows="3"
        v-model="novopedido.observacao"
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default { 
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("pedidos", ["novopedido"]),
  },
  methods: {
    ...mapGetters("pedidos", ["getTipoPedidoSelec","selecionouProdutoSaldoContrato"]),    
  },
};
</script>

<style>
</style>